import { PERMISSIONS, hasPermission } from '@/lib/permissions';
import { GROUP_DM_PERMISSIONS, GROUP_DM_PERMISSIONS_ALL, type DirectChannel } from '@/types/api';
import type { SavedChannelKind } from '@/lib/savedMessages';

/**
 * May the current user pin messages here? Mirrors the server's pin route:
 * guild channels need PIN_MESSAGES, either participant of a 1:1 DM may pin,
 * and in a group DM the owner/admins may, members only when the group allows
 * it. Offering «Закрепить» to anyone else was a button that always failed.
 */
export function canPinIn(opts: {
  channelKind: SavedChannelKind;
  guildPermissions: bigint;
  dmChannel: Pick<DirectChannel, 'memberPermissions' | 'directParticipants'> | undefined;
  myId: string | null;
}): boolean {
  switch (opts.channelKind) {
    case 'TEXT':
    case 'ANNOUNCE':
      return hasPermission(opts.guildPermissions, PERMISSIONS.PIN_MESSAGES);
    case 'DM':
      return true;
    case 'GROUP_DM': {
      const role = opts.dmChannel?.directParticipants.find((p) => p.userId === opts.myId)?.role;
      if (role === 'OWNER' || role === 'ADMIN') return true;
      if (!role) return false;
      const memberPermissions = opts.dmChannel?.memberPermissions ?? GROUP_DM_PERMISSIONS_ALL;
      return (memberPermissions & GROUP_DM_PERMISSIONS.PIN_MESSAGES) === GROUP_DM_PERMISSIONS.PIN_MESSAGES;
    }
  }
}
